module.exports = __webpack_public_path__ + "static/media/partner-btm-3.68c270f8.png";